import type { ReactNode } from 'react'
import { AlertTriangle, RotateCw } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Khối báo "không tải được số liệu" + nút thử lại. Dùng thay cho việc nuốt
 * lỗi rồi hiện số 0: người dùng nhìn số 0 sẽ tưởng là không có đơn.
 */
export function LoadError({
  onRetry,
  children = 'Không tải được số liệu.',
  className,
}: {
  onRetry?: () => void
  children?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-4 py-8 text-center', className)} role="alert">
      <span className="grid size-10 place-items-center rounded-full bg-danger/10 text-danger">
        <AlertTriangle className="size-5" aria-hidden />
      </span>
      <p className="text-sm text-inkSoft">{children}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="motion-state inline-flex min-h-11 items-center gap-1.5 rounded-lg border border-rule bg-raise px-3 text-sm font-medium text-ink hover:bg-paperSoft desktop:min-h-9"
        >
          <RotateCw className="size-4" aria-hidden /> Thử lại
        </button>
      )}
    </div>
  )
}
